export default "/signup/_next/static/chunks/fonts/inter-v3-latin-500-501c835bfa9ca916c4eee5661b947e39.eot";